import React from 'react';
import { Key, Plus, Copy, RefreshCw, Trash } from 'lucide-react';
import { Button } from '../ui/button';

export const APISettings = () => {
  return (
    <div className="space-y-6">
      <div className="bg-[#0F1629] rounded-xl border border-gray-800/50 p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <Key className="h-5 w-5 text-blue-500" />
            <h2 className="text-lg font-semibold text-white">API Keys</h2>
          </div>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Create API Key
          </Button>
        </div>

        <div className="space-y-6">
          {/* API Keys List */}
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center justify-between p-4 bg-gray-800/30 rounded-lg group">
                <div className="space-y-1">
                  <div className="text-sm font-medium text-white">Production API Key {i}</div>
                  <div className="text-sm text-gray-400">Created on Feb 28, 2024</div>
                  <div className="flex items-center space-x-2">
                    <code className="px-2 py-1 text-xs font-mono bg-gray-800/50 rounded text-gray-300">
                      sk_live_••••••••••••••••
                    </code>
                    <button className="p-1 rounded hover:bg-gray-800/50 text-gray-400 hover:text-white transition-colors">
                      <Copy className="h-4 w-4" />
                    </button>
                  </div>
                </div>
                <div className="flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Button variant="outline" size="sm">
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Rotate
                  </Button>
                  <Button variant="outline" size="sm" className="text-red-500 hover:text-red-400">
                    <Trash className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>

          {/* API Documentation */}
          <div className="pt-6 border-t border-gray-800">
            <h3 className="text-sm font-medium text-white mb-4">API Documentation</h3>
            <div className="prose prose-invert">
              <p className="text-sm text-gray-400">
                Learn how to integrate our API into your applications. Check out our comprehensive API documentation for detailed instructions and examples.
              </p>
              <Button variant="outline" className="mt-4">
                View Documentation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};